module.exports = __webpack_public_path__ + "static/img/GN_H5.fde2a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/GN_H5.png
// module id = qPak
// module chunks = 34